export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-archive-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-circle-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-bear-smile-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-circle-line' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const comparisonPlatforms = [
  {
    name: 'Hipobuy Spreadsheet',
    bestFor: 'Product discovery & organized shopping',
    features: ['Structured categories', 'Product references', 'Buying insights', 'Regular updates'],
  },
  {
    name: 'Kakobuy Spreadsheet',
    bestFor: 'Alternative shopping research',
    features: ['Cross-platform comparison', 'Price tracking', 'Vendor listings', 'Community feedback'],
  },
  {
    name: 'CSSBuy Spreadsheet',
    bestFor: 'Agent comparison & selection',
    features: ['Agent ratings', 'Service comparison', 'Fee breakdown', 'Shipping options'],
  },
  {
    name: 'Superbuy Spreadsheet',
    bestFor: 'Beginner-friendly shopping guides',
    features: ['Step-by-step tutorials', 'Visual guides', 'New user resources', 'FAQ database'],
  },
  {
    name: 'Oopbuy Spreadsheet',
    bestFor: 'Alternative sourcing research',
    features: ['Supplier directories', 'Product catalogs', 'Pricing analysis', 'Order tracking'],
  },
];